import { SpineBase, ingenuity, Container, dispatcher, Graphics } from "@quest/base-core/dist";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist/Model/Model";

import { FgStackSymbolView } from "./FgStackSymbolView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";

export class FgStackSymbolController {
  private view: FgStackSymbolView;
  private stackSymbolContainer: Container;

  constructor(view: FgStackSymbolView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
  }

  /**
   * Initialize Elements
   */
  private initializeElements(): void {
    this.stackSymbolContainer = this.view.getContainerByID("stackSymbolMainConatiner");
    (this.stackSymbolContainer.mask as Graphics) = this.view.getShapeById("stackSymbolMask");
  }

  /**
   * Subscribe events
   */
  private subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.START_FG_STACK_SYMBOL_WIN_ANIMATION, this.alignFgStackSymbol, this);
    dispatcher.on(eventDispatchers.HIDE_FG_STACK_SYMBOL_WIN_ANIMATION, this.hideFgStackSymbol, this);
  }

  /**
   * Unsubscribe events
   */
  private unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.START_FG_STACK_SYMBOL_WIN_ANIMATION, this.alignFgStackSymbol, this);
    dispatcher.off(eventDispatchers.HIDE_FG_STACK_SYMBOL_WIN_ANIMATION, this.hideFgStackSymbol, this);
  }

  /**
   * Add to align fg stack symbols win animation
   */
  private alignFgStackSymbol(): void {
    const reelGrid: number[][] = (ingenuity.parserModel as platformModel).getReelGrid();
    let stackData: number[][] = gameConstants.MAN_AND_LADY_STACK_DATA;
    stackData.forEach((value: number[]) => {
      for (let i = 0; i < reelGrid.length; i++) {
        for (let j = 0; j < reelGrid[i].length; j++) {
          if (reelGrid[i][j] === value[2]) {
            const top: number = 0;
            const stackTopSpine: SpineBase = this.alignFgSpine(i, top, j, value[2]);
            const topOffSet: number[][] = this.setFgOffset(i, j, reelGrid[i].length, value[1]);
            this.playFgStackAnimation(topOffSet, stackTopSpine, value[1]);
            for (let k = j + value[1]; k < reelGrid[i].length; k++) {
              if (reelGrid[i][k] === value[2]) {
                const bottom: number = 1;
                const stackBottomSpine: SpineBase = this.alignFgSpine(i, bottom, k, value[2]);
                const bottomOffSet: number[][] = this.setFgOffset(i, k, reelGrid[i].length, value[1]);
                this.playFgStackAnimation(bottomOffSet, stackBottomSpine, value[1]);
                break;
              }
            }
            break;
          }
        }
      }
    }, this);
  }

  /**
   * Allign fg Spine
   */
  private alignFgSpine(reelId: number, childNumber: number, symIndex: number, stackId: number): SpineBase {
    let selectedStack;
    if (stackId === gameConstants.MAN_SYMBOL_1X3_STACK_ID || stackId === gameConstants.MAN_SYMBOL_1X5_STACK_ID) {
      selectedStack = "Man";
    }
    const stackSpineContainer: Container = this.view.getContainerByID("reelConatiner_" + selectedStack + "_" + reelId);
    const stackSpine: SpineBase = stackSpineContainer.children[childNumber];
    stackSpine.y = this.view.json.stackSymbolYArray[symIndex];
    stackSpine.visible = false;
    return stackSpine;
  }

  /**
   * Add to play fg stack symbol animation
   */
  private playFgStackAnimation(StackOffset: number[][], stackAnimation: SpineBase, stackSize: number): void {
    let winDataOffSet = (ingenuity.parserModel as platformModel).getWinLinesData()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
        (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ].positions;
    let flag: boolean = false;
    for (let offset of StackOffset) {
      for (let winOffset of winDataOffSet) {
        if (offset[0] === winOffset[0] && offset[1] === winOffset[1]) {
          flag = true;
          break;
        }
      }
    }
    if (flag === true) {
      stackAnimation.visible = true;
      stackAnimation.setPause(false);
      const stackAnim: string = "symbol_character_1x" + stackSize;
      stackAnimation.playAnim(stackAnim, true);
    }
  }

  /**
   * Set Fg stack symbol win offset
   */
  private setFgOffset(reelId: number, symIndex: number, reelGridLength: number, stackSize: number): number[][] {
    let offset: number[][] = [];
    for (let index = symIndex; index < reelGridLength; index++) {
      const pos: number[] = [reelId, index];
      offset.push(pos);
      if (offset.length === stackSize) {
        break;
      }
    }
    return offset;
  }

  /**
   * Add to hide fg stack symbol
   */
  private hideFgStackSymbol(): void {
    this.stackSymbolContainer.forEach((child: Container) => {
      child.forEach((reelConatiner: Container) => {
        reelConatiner.forEach((stackSpine: SpineBase) => {
          stackSpine.visible = false;
          stackSpine.setPause(true);
        }, this);
      }, this);
    }, this);
  }

  // Add to unsubscribe events
  public destroy(): void {
    this.unsubscribeEvents();
  }
}
